// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"profile_profileCard__3nSIG"};